import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import ComponentErrorBoundary from "@/components/shared/business/ComponentErrorBoundary/ComponentErrorBoundary";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import TableCreatorNavigationTableWrapper from "@FillInTableContainer/shared/components/TableCreatorNavigationTableWrapper/TableCreatorNavigationTableWrapper";
import { CompanyWebsiteVariousPagesLayoutValue } from "@FillInTableContainer/shared/types/tableCreator.types";
import {
  getGroupTableTitle,
  getLayoutFromData,
} from "@FillInTableContainer/shared/utils/getTextFromData";

import CompanyWebsiteVariousPagesTableCreatorGroupTable from "./components/CompanyWebsiteVariousPagesTableCreatorGroupTable/CompanyWebsiteVariousPagesTableCreatorGroupTable";

const CompanyWebsiteVariousPagesTableCreator = () => {
  const layout = getLayoutFromData(
    ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages,
  ) as CompanyWebsiteVariousPagesLayoutValue;

  const errorWithComponent = (title: string) => (
    <TableCreatorGroupTableTitle title={title} isRequired={false} />
  );

  return (
    <TableCreatorNavigationTableWrapper
      classificationKey={ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages}
    >
      <>
        {layout.map(({ groupTableKey, tableList }, groupTableIndex) => (
          <ComponentErrorBoundary
            addComponents={errorWithComponent(
              getGroupTableTitle(
                ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages,
                groupTableKey,
              ),
            )}
          >
            <CompanyWebsiteVariousPagesTableCreatorGroupTable
              key={`group-table-${String(groupTableIndex)}`}
              groupTableKey={groupTableKey}
              tableList={tableList}
              groupTableIndex={groupTableIndex}
            />
          </ComponentErrorBoundary>
        ))}
      </>
    </TableCreatorNavigationTableWrapper>
  );
};

export default CompanyWebsiteVariousPagesTableCreator;
